export const DeliverStatusCssClasses = [
  'primary',
  'warning',
  'success',
  'dark',
  'muted',
];
export const DeliverStatusTitles = [
  'Шинэ',
  'Хүргэлтэнд өгсөн',
  'Имэйл илгээсэн',
  'Хаагдсан',
  'Цуцалсан',
];
export const deliverStatusList = [
  { key: -1, value: 'Төлөв' },
  { key: 0, value: 'Шинэ' }, // .primary
  { key: 1, value: 'Хүргэлтэнд өгсөн' }, //.warning
  { key: 2, value: 'Имэйл илгээсэн' }, // .success
  { key: 3, value: 'Хаагдсан' }, //.dark
  { key: 9, value: 'Цуцалсан' }, //.muted
];

export const defaultSorted = [{ dataField: 'ship_date', order: 'desc' }];
export const sizePerPageList = [
  { text: '10', value: 10 },
  { text: '20', value: 20 },
  { text: '50', value: 50 },
];
export const initialFilter = {
  filter: {
    from: '', //Date.now(),
    to: '', //"",
    searchText: '',
    status: -1,
  },
  sortOrder: 'desc', // asc||desc
  sortField: 'ship_date',
  pageNumber: 1,
  pageSize: 10,
};

export const initialDeliver = {
  deliverCode: undefined,
  shipDate: '',
  saleCount: 0,
  totalFee: '0',
  deliveredDate: '',
  sentEmail: 0,
  status: 0,
  note: '',
  sales: [],
};
